import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import type { AuthState } from '@zendia/frontend-shared'
import { z } from 'zod'

export const Route = createFileRoute('/_unauthenticated')({
  component: UnauthenticatedContainer,
  validateSearch: z.object({
    redirect: z.string().optional().catch(''),
    // Lets a route that bounces the user here explain why, so landing on the login form
    // is an instruction rather than a surprise.
    notice: z.string().optional().catch(''),
  }),
  beforeLoad: (ctx) => {
    const authToken = (ctx.context?.auth as AuthState)?.authToken
    const isOnboardingRoute = ctx.location.pathname.startsWith('/onboarding')
    // A token in storage is not proof that it still works. Bouncing /login away
    // whenever one is present leaves a user with an expired token unable to sign
    // in again, so the login route decides for itself where an already
    // authenticated user belongs once their settings have been loaded.
    const isLoginRoute = ctx.location.pathname.startsWith('/login')
    if (authToken && !isOnboardingRoute && !isLoginRoute) {
      throw redirect({ to: ctx.search.redirect || '/dashboard' })
    } else if (ctx.location.pathname === '/') {
      throw redirect({ to: '/login' })
    }
  },
})

function UnauthenticatedContainer() {
  return (
    <div className="h-dvh">
      <Outlet />
    </div>
  )
}
